import styled from 'styled-components'
import PhoneInput from 'react-phone-input-2'
import OtpInput from 'react-otp-input'
import 'react-phone-input-2/lib/style.css'

// CAMC: Clubbed Auth Main Component

export const CAMCParent = styled.div`
  width: 100%;
  max-width: 310px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  font-family: 'Outfit', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  box-sizing: border-box;
  @media (min-width: 768px) {
    max-width: 600px;
    width: 600px;
  }
`

export const CAMCHeading = styled.div`
  font-size: ${(props) => (props.secondary ? '26px' : '32px')};
  font-weight: 700;
  max-width: 315px;
  width: 100%;
  text-align: center;
  font-family: 'Outfit', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  box-sizing: border-box;
  @media (max-width: 767px) {
    max-width: 100%;
    font-size: ${(props) => (props.secondary ? '22px' : '28px')};
    padding: 0 5px;
  }
  @media (min-width: 768px) {
    text-align: left;
    font-size: ${(props) => (props.secondary ? '34px' : '40px')};
  }
`

export const CAMCMaxWithRelativeContainer = styled.div`
  width: 100%;
  max-width: 315px;
  position: relative;
  box-sizing: border-box;
  @media (max-width: 767px) {
    max-width: 100%;
    padding: 0 5px;
  }
`

export const CAMCMethodButtonContainer = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'loading',
})`
  width: 100%;
  max-width: 315px;
  font-weight: 500;
  border-radius: 500px;
  text-align: center;
  text-decoration: none;
  touch-action: manipulation;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #242424;
  border: 1px solid #707070;
  padding: 7px 31px 7px 55px;
  position: relative;
  transition: all 0.3s ease-in-out;
  font-family: 'Outfit', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  cursor: pointer;
  box-sizing: border-box;
  @media (max-width: 767px) {
    max-width: 100%;
    padding: 7px 20px 7px 50px;
  }
  &:hover:not(:disabled) {
    border-color: #514387;
    background-color: #f5f3ff;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(81, 67, 135, 0.2);
  }
  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(81, 67, 135, 0.15);
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

export const CAMCMethodButtonImage = styled.img`
  position: absolute;
  left: 22px;
  width: 22px;
  height: 22px;
  object-fit: contain;
  display: block;
`

export const CAMCGeneralButton = styled(CAMCMethodButtonContainer).withConfig({
  shouldForwardProp: (prop) => prop !== 'loading' && prop !== 'success',
})`
  padding: 7px 31px 7px 31px;
  min-height: 40px;
  ${(props) => props?.success && !props?.loading && 'background: #514387'};
  ${(props) => props?.success && !props?.loading && 'color: #fff'};
  ${(props) => props?.success && props?.loading && `
    background: #514387 !important;
    color: #fff !important;
    border-color: #514387 !important;
  `};
  ${(props) => props?.success && `
    &:hover:not(:disabled) {
      background: #6350a0;
      border-color: #6350a0;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(81, 67, 135, 0.3);
    }
    &:active:not(:disabled) {
      background: #453a6f;
      transform: translateY(0);
      box-shadow: 0 2px 6px rgba(81, 67, 135, 0.25);
    }
  `};
  
  &:disabled {
    cursor: not-allowed !important;
    pointer-events: none;
    
    ${(props) => props?.success && props?.loading && `
      background: #514387 !important;
      color: #fff !important;
      border-color: #514387 !important;
      opacity: 0.9 !important;
    `};
    
    ${(props) => props?.success && !props?.loading && `
      background: transparent !important;
      color: #707070 !important;
      border-color: #707070 !important;
      opacity: 0.6 !important;
    `};
    
    ${(props) => !props?.success && `
      background: transparent !important;
      color: #707070 !important;
      border-color: #707070 !important;
      opacity: 0.6 !important;
    `};
  }
`

export const CAMCSeparator = styled.div`
  background: #707070;
  width: 100%;
  height: 1px;
`

export const CAMCGeneralInputLabel = styled.label`
  font-weight: 600;
  color: #242424;
  font-family: 'Outfit', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
`

export const CAMCGeneralInput = styled.input`
  width: 100%;
  max-width: 100%;
  border-radius: 5px;
  display: flex;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  color: #242424;
  border: 1px solid #707070;
  padding: 7px 35px 7px 7px;
  position: relative;
  transition: all 0.3s ease-in-out;
  font-family: 'Outfit', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  box-sizing: border-box;
  font-size: 16px; /* Prevents zoom on iOS */
  @media (max-width: 767px) {
    padding: 7px 30px 7px 7px;
    font-size: 16px; /* Prevents zoom on iOS */
  }
  &:hover {
    border-color: #000;
  }
  &:focus {
    outline: none;
  }
`

export const CAMCErrorText = styled.div`
  width: 100%;
  max-width: 315px;
  color: #cc0000;
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: 'Outfit', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  box-sizing: border-box;
  @media (max-width: 767px) {
    max-width: 100%;
    padding: 0 5px;
    font-size: 14px;
  }
`

export const CAMCPhoneInput = styled(PhoneInput)`
  width: 100%;
  max-width: 315px;
  position: relative;
  box-sizing: border-box;
  
  /* Completely remove CSS sprite flags - replaced with high-quality images */
  .flag {
    background-image: none !important;
    background-position: unset !important;
    background-size: unset !important;
  }
  
  .form-control {
    width: 100%;
    height: 40px;
    border: 1px solid #707070;
    border-radius: 5px;
    color: #242424;
    background: #ffffff;
    font-size: 16px;
    font-weight: 400;
    padding-left: 48px;
    transition: all 0.3s ease-in-out;
    font-family: 'Outfit', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    
    &:focus {
      outline: none;
      box-shadow: none;
      border-color: #514387;
    }
    
    &:hover {
      border-color: #000;
    }
  }
  
  .flag-dropdown {
    border: none;
    background: transparent;
    border-right: 1px solid #d9d9d9;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    border-radius: 5px 0 0 5px;
    z-index: 1;
    
    &:hover,
    &:focus {
      background: transparent;
    }
  }
  
  .selected-flag {
    padding: 0 0 0 8px;
    width: 48px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent !important;
    position: relative;
    overflow: hidden;
    
    &:hover,
    &:focus {
      background: transparent !important;
    }
  }
  
  /* Hide duplicate flags - show only the first visible flag */
  .selected-flag .flag {
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px !important;
    height: 15px !important;
    visibility: hidden;
    opacity: 0;
    z-index: -1;
  }
  
  .selected-flag .flag:first-of-type,
  .selected-flag .flag:first-child,
  .selected-flag .flag:not([style*="display: none"]) {
    visibility: visible !important;
    opacity: 1 !important;
    position: relative !important;
    left: auto !important;
    top: auto !important;
    transform: none !important;
    z-index: 2 !important;
    display: inline-block !important;
    margin: 0 !important;
    vertical-align: middle !important;
    flex-shrink: 0;
    /* Completely remove CSS sprite - replaced by img elements via JS */
    background-image: none !important;
    background-position: unset !important;
    background-size: unset !important;
  }
  
  /* Ensure flag images load properly */
  .selected-flag .flag img.flag-img {
    width: 20px;
    height: 15px;
    object-fit: contain;
    display: inline-block;
    vertical-align: middle;
  }
  
  /* Hide duplicate arrows - show only the last one */
  .selected-flag .arrow,
  .selected-flag [class*="arrow"] {
    display: none !important;
  }
  
  .selected-flag .arrow:last-of-type,
  .selected-flag .arrow:last-child,
  .selected-flag [class*="arrow"]:last-of-type {
    display: inline-block !important;
    margin-left: 4px !important;
    vertical-align: middle !important;
    flex-shrink: 0;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #242424;
    position: relative;
    z-index: 2;
  }
  
  .country-list {
    background: #ffffff !important;
    border: 1px solid #707070 !important;
    border-radius: 5px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
    max-height: 200px !important;
    width: 300px !important;
    z-index: 99999 !important;
    position: fixed !important;
    overflow-y: auto !important;
    display: block !important;
  }
  
  .country-list .country {
    display: flex !important;
    align-items: center !important;
    padding: 8px 10px !important;
    color: #242424 !important;
  }
  
  .country-list .flag {
    display: inline-block !important;
    width: 20px !important;
    height: 15px !important;
    margin-right: 8px !important;
    /* Remove CSS sprite */
    background-image: none !important;
    background-position: unset !important;
    background-size: unset !important;
  }
  
  .country-list .flag img.flag-img {
    width: 20px;
    height: 15px;
    object-fit: contain;
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }
  
  .country {
    display: flex;
    padding: 8px 10px;
    color: #242424;
    
    &:hover {
      background: #f5f5f5;
    }
  }
  
  .country-name {
    color: #242424;
    flex: 1;
    margin-right: 8px;
  }
  
  .dial-code {
    color: #707070;
    font-size: 14px;
  }
  
  .search {
    background: #ffffff;
    padding: 10px;
    position: sticky;
    top: 0;
    z-index: 1;
  }
  
  .search-box {
    width: 100%;
    padding: 6px 10px;
    border: 1px solid #d9d9d9;
    border-radius: 3px;
    font-size: 14px;
    color: #242424;
    
    &:focus {
      outline: none;
      border-color: #514387;
    }
  }
  
  .special-label {
    display: none;
  }
  
  @media (max-width: 767px) {
    max-width: 100%;
    
    .form-control {
      font-size: 16px; /* Prevents zoom on iOS */
    }
  }
`

export const CAMCCaptcha = styled.div`
  /* Invisible reCAPTCHA container - positioned absolutely to not affect layout */
  position: absolute;
  visibility: hidden;
  height: 0;
  overflow: hidden;
`

export const CAMCOtpInput = styled(OtpInput)`
  width: 100%;
  max-width: 315px;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  
  input {
    width: 100% !important;
    height: 48px;
    border: 1px solid #707070;
    border-radius: 8px;
    background: #ffffff;
    font-size: 20px;
    font-weight: 600;
    color: #242424;
    text-align: center;
    transition: all 0.3s ease-in-out;
    font-family: 'Outfit', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    
    &:focus {
      outline: none;
      border-color: #514387;
      box-shadow: 0 0 0 2px rgba(81, 67, 135, 0.1);
    }
    
    &:hover {
      border-color: #000;
    }
  }
  
  @media (max-width: 767px) {
    gap: 6px;
    
    input {
      height: 44px;
      font-size: 18px;
    }
  }
`

export const CAMCResendOtpContainer = styled.div`
  width: 100%;
  max-width: 315px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
  font-size: 14px;
  color: #707070;
  font-family: 'Outfit', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  box-sizing: border-box;
  @media (max-width: 767px) {
    max-width: 100%;
    padding: 0 5px;
    font-size: 13px;
  }
  
  span {
    color: #514387;
    font-weight: 600;
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
    
    &[data-disabled="true"] {
      color: #707070;
      cursor: default;
      text-decoration: none;
    }
  }
`
